import 'bootstrap-2.3.2/js/bootstrap-transition'
import 'bootstrap-2.3.2/js/bootstrap-alert'
import 'bootstrap-2.3.2/js/bootstrap-modal'
import './boostrap-dropdown-custom'
import 'bootstrap-2.3.2/js/bootstrap-scrollspy'
import 'bootstrap-2.3.2/js/bootstrap-tooltip'
import 'bootstrap-2.3.2/js/bootstrap-popover'
import 'bootstrap-2.3.2/js/bootstrap-button'
import 'bootstrap-2.3.2/js/bootstrap-collapse'
import 'bootstrap-2.3.2/js/bootstrap-carousel'
import 'bootstrap-2.3.2/js/bootstrap-typeahead'
import 'bootstrap-2.3.2/js/bootstrap-affix'
;(function ($) {
  $(function () {
    $('div.bootstrap-modal').modal()
    $('div.bootstrap-modal').modal('hide').addClass('fade')

    $('a.bootstrap-modal-cancel-button').click(function (event) {
      $(event.target).closest('div.modal').modal('hide')
    })
  })
})(jQuery)
